import 'angular/plugins/controllers';

const modules = [
    'ngRoute',
    'graphdb.framework.plugins.controllers'
];

angular.module('graphdb.framework.plugins', modules);
